export const ADD_CREDIT_CARD = 'ADD_CREDIT_CARD'
export const ADD_CREDIT_CARD_FAILED = 'ADD_CREDIT_CARD_FAILED'
export const RESET_ERROR_STATE = 'RESET_ERROR_STATE'
export const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS'
export const ADD_CREDIT_CARD_RESET = 'ADD_CREDIT_CARD_RESET'
